<template>
  <v-app>
    <NuxtLoadingIndicator />
    <NuxtLayout>
      <SystemBanners />
      <NuxtPage />
    </NuxtLayout>
  </v-app>
</template>
